module.exports = __webpack_public_path__ + "static/media/men.edef10c2.jpg";